export const serviceOptions = (key, options = []) => {
  switch (key) {
    case 'CHANNEL_BUY':
      return options?.map((item) => ({
        label: item.channelBuyNameTh,
        value: item.channelBuyId,
      }));
    case 'MOBILE_BRAND':
      return options?.map((brand) => ({
        label: brand.mobileBrandNameTh,
        value: brand.mobileBrandId,
      }));
    case 'PROVINCE':
      const provinceOptions = options?.map((item) => ({
        label: item.provinceNameTh,
        value: item.provinceId,
      }));
      return provinceOptions;
    case 'DISTRICT':
      const districtOptions = options?.map((item) => ({
        label: item.districtNameTh,
        value: item.districtId,
      }));
      return districtOptions;
    case 'SUBDISTRICT':
      const subDistrictOptions = options?.map((item) => ({
        label: item.subDistrictNameTh,
        value: item.subDistrictId,
      }));
      return subDistrictOptions;
    case 'BREAKDOWN_SUB':
      const breakdownSubOptions = options?.map((item) => ({
        label: item.breakdownSubNameTh,
        value: item.breakdownSubId,
      }));
      return breakdownSubOptions;
  }
};
